import PopPdfPopover from '@sophocles/views/sites/components/PopPdfPopover/PopPdfPopover';

export default PopPdfPopover;
